import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { getEntity as getEquipment } from '../../redux/actions/equipmentsActions';
import { isEmptyObject, isUndefined } from '../../utils/utils';
import { Grid, Typography } from '@material-ui/core';
import useStyles from './styles';

type IRDProps = {
  id: string;
};

type EquipmentType = {
  id: number;
  description: string;
  model: string;
  category: any;
  supplier: any;
  region?: string;
  approval_type?: any;
  is_core?: boolean;
  is_visible_for_franchise?: boolean;
  is_active?: boolean;
};

const EquipmentDetails = () => {
  const { id } = useParams<IRDProps>();
  const classes = useStyles();
  const dispatch: any = useDispatch();
  const equipment: EquipmentType = useSelector(
    (state: RootStateOrAny) => state.EquipmentsReducer.entity,
  );

  const equipmentLoaded = useSelector(
    (state: RootStateOrAny) => state.EquipmentsReducer.entityLoaded,
  );
  useEffect(() => {
    dispatch(getEquipment(id));
  }, []);
  return (
    <div>
      {equipmentLoaded &&
        (isEmptyObject(equipment) ? (
          <Typography
            className={`${classes.marginStyle} ${classes.textAlignCenter}`}
          >
            There is no information available
          </Typography>
        ) : (
          <Grid container spacing={1}>
            {!isUndefined(equipment.region) && (
              <Grid item lg={2}>
                <Typography variant="caption">Availability</Typography>
                <div className={classes.textFlex}>
                  <div className={classes.textFlexCenter}>
                    <Typography>{equipment.region}</Typography>
                    <Typography variant="caption">Region</Typography>
                  </div>
                </div>
              </Grid>
            )}
            <Grid item lg={10}>
              <Typography variant="caption">Equipment Information</Typography>
              <div className={classes.flexCenter}>
                {!isUndefined(equipment.approval_type) && (
                  <div className={classes.textFlexCenter}>
                    <Typography>{equipment.approval_type?.name}</Typography>
                    <Typography variant="caption">Approval Type</Typography>
                  </div>
                )}
                {!isUndefined(equipment.is_core) && (
                  <div className={classes.textFlexCenter}>
                    <Typography>
                      {equipment.is_core ? 'Core' : 'Non-core'}
                    </Typography>
                    <Typography variant="caption">Core</Typography>
                  </div>
                )}
                <div className={classes.textFlexCenter}>
                  <Typography>{equipment.category?.name}</Typography>
                  <Typography variant="caption">Category</Typography>
                </div>
                <div className={classes.textFlexCenter}>
                  <Typography>{equipment.description}</Typography>
                  <Typography variant="caption">Description</Typography>
                </div>
                <div className={classes.textFlexCenter}>
                  <Typography>{equipment.supplier?.name}</Typography>
                  <Typography variant="caption">
                    Manufacturer/Supplier
                  </Typography>
                </div>
                <div className={classes.textFlexCenter}>
                  <Typography>{equipment.model}</Typography>
                  <Typography variant="caption">Model/Series</Typography>
                </div>
                {!isUndefined(equipment.is_active) && (
                  <div className={classes.textFlexCenter}>
                    <Typography>
                      {equipment.is_active ? 'Active' : 'Inactive'}
                    </Typography>
                    <Typography variant="caption">Status</Typography>
                  </div>
                )}
                {!isUndefined(equipment.is_visible_for_franchise) && (
                  <div className={classes.textFlexCenter}>
                    <Typography>
                      {equipment.is_visible_for_franchise
                        ? 'Yes'
                        : 'Non-visible'}
                    </Typography>
                    <Typography variant="caption">
                      Visible for Franchise
                    </Typography>
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
        ))}
    </div>
  );
};

export default EquipmentDetails;
